import { Card, Stack, Typography } from "@mui/material";
import type { InvestorCommunicationType } from "../../../api/types/investorCommunicationsTypes";
import { investorCommunicationTypeCaptionsMap } from "../../../utilities/enumCaptions";
import InvestorCommunicationTypeAvatar from "./InvestorCommunicationTypeAvatar";

interface Props {
  type: InvestorCommunicationType;
  description: string;
  disabled?: boolean;
  selected?: boolean;
  onClick: () => void;
}

const NewInvestorCommunicationTypeCard = ({ type, description, disabled, selected, onClick }: Props) => (
  <Card
    variant="outlined"
    onClick={disabled ? undefined : onClick}
    sx={(t) => ({
      p: 2,
      ...(!disabled && {
        cursor: "pointer",
        ":hover": { borderColor: t.palette.primary.main },
      }),
      ...(selected && { borderColor: t.palette.primary.main }),
    })}
  >
    <Stack direction="row" spacing={2}>
      <InvestorCommunicationTypeAvatar type={type} size={40} />
      <Stack spacing={0.5}>
        <Typography variant="subtitle1">{investorCommunicationTypeCaptionsMap[type]}</Typography>
        <Typography color="textSecondary">{description}</Typography>
      </Stack>
    </Stack>
  </Card>
);

export default NewInvestorCommunicationTypeCard;
